
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/shared/tree-browser-view/jst/TreeBrowser';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<ul role=\"tree\" tabindex=\"0\" activedescendent=\"\" class=\"tree\"\n  aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("tree_browser")
  },data:data},helper ? helper.call(depth0, "folder_browsing_tree_1f00a3ae", "Folder Browsing Tree", options) : helperMissing.call(depth0, "t", "folder_browsing_tree_1f00a3ae", "Folder Browsing Tree", options)))
    + "\"\n></ul>";
  return buffer;
  });
    ;
    
    import brandableCss from '@canvas/brandable-css';

    brandableCss.loadStylesheetForJST({
      id: 'c5',
      bundle: 'jst/TreeBrowser'
    });
  ;
    export default templates[name];
  